import { faEraser, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Box, Button } from "react-bulma-components";

export type DrawingMode = "none" | "pen" | "eraser";

type Props = {
    onModeChanged: (mode: DrawingMode) => void;
};

export default function DrawingControls({ onModeChanged }: Props) {
    const [mode, setMode] = useState<DrawingMode>("pen");

    function changeMode(mode: DrawingMode) {
        setMode(mode);
        onModeChanged(mode);
    }

    return (
        <Box
            style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                margin: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                padding: 10,
                borderRadius: 14
            }}>
            <Button
                style={{
                    backgroundColor: mode === "pen" ? "#3e56c4" : "transparent",
                    borderRadius: 14,
                    border: "none"
                }}
                onClick={() => changeMode("pen")}>
                <FontAwesomeIcon icon={faPen} color="white" />
            </Button>
            <Button
                style={{
                    backgroundColor: mode === "eraser" ? "#3e56c4" : "transparent",
                    borderRadius: 14,
                    border: "none"
                }}
                onClick={() => changeMode("eraser")}>
                <FontAwesomeIcon icon={faEraser} color="white" />
            </Button>
        </Box>
    );
}
